import React from "react";

export default function GetStarted({ onGetStarted }) {
  return (
    <button
      className="bg-gradient-to-r from-blue-500 to-blue-700 text-white text-lg px-8 py-3 rounded-lg shadow hover:from-blue-700 hover:to-blue-900 font-bold transition"
      onClick={onGetStarted}
    >
      Get Started – Generate Your First Report
    </button>
  );
}